import { Chip, Tooltip, Typography, type ChipProps } from "@mui/material";
import React from "react";

export function PromiseToPayBrokenTag(props: ChipProps) {
  const { sx, ...restProps } = props;
  return (
    <Chip
      label={
        <Tooltip title="Promise to Pay Broken" arrow>
          <Typography fontSize={12}>P.T.P. broken</Typography>
        </Tooltip>
      }
      color="error"
      size="small"
      sx={{
        height: "unset",
        borderRadius: "4px",
        "& > .MuiChip-label": { paddingLeft: "4px", paddingRight: "4px" },
        ...sx,
      }}
      {...restProps}
    />
  );
}
